import { render } from "./MaterisalsArticles.vue?vue&type=template&id=6099b7db&scoped=true"
import script from "./MaterisalsArticles.vue?vue&type=script&lang=js"
export * from "./MaterisalsArticles.vue?vue&type=script&lang=js"

import "./MaterisalsArticles.vue?vue&type=style&index=0&id=6099b7db&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6099b7db"]])

export default __exports__